他<template>
  <div class="ThreeLinkagePanel">
    <div class="h-topo_pw2" v-show="see" style="width:330px;height:550px; background:#000000; opacity: 0.80;border-radius:4px;" :style="PositionXY">

      <div class="topo-title" style="width:100%; ">
          	<i :class="['icon hero-icon '+icon+ ' '+ online +' h-topo_topwz_i']" ></i>
            <label class="topo_title_w200" style="margin: 12px 0 0 10px;" :title='serviceName'>{{$t('Topo.serviceName')}}：{{serviceName}}</label>
           
        	<a style="cursor:pointer;float: right;margin: 8px 0 0 0;">
	          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-remove-small"  style="color:#ddd;" :title="$t('Common.close')"></span>
	        </a>             
      </div>
      
      <div style="width:100%;height:520px;"> 
      		 
      		 <!-- Begin Form Type One -->
      		 <div class="h-topo_content" style="height:auto; width: 100%; margin-top:0;">	
      		 
      		 	<label class="formTitle" style="padding: 0 0 0 12px;">{{$t('Topo.runningStatus')}}</label>	
      		 	<div>   
      		 		<div class="col-md-6" style="padding: 0 12px 0 12px;"><span> {{$t('Topo.ip')}} : </span> {{ip}} 	 </div>      		 	
      		 		<div class="col-md-6" style="padding: 0 12px 0 12px;"><span> {{$t('Topo.cpuUsage')}} : </span> {{cpuUsage}} 	   </div>
					<div class="col-md-6" style="padding: 0 12px 0 12px;"><span> {{$t('Topo.memoryUsage')}} : </span> {{memoryUsage}} 	 </div>   
      		 	</div>					 
		     </div>  
		      				
	      	 <hr style=" margin: 15px 5px 10px 12px;border-color: #dddddd;"/>
	      	 <!-- /.END Form Type One --> 
	      	 
	      	 <!-- Begin Form Type Two -->
		     <div style="min-height:180px;margin-top: 0;">		       		
		       		<ejs-grid ref='gridPhysicPOD' id='gridPhysicPOD' gridLines='None' :dataSource="dsPOD" ::enableHover='false' 
					        rowHeight="20" :allowSelection='true' :selectionSettings='selectOptions' :rowSelected="rowSelectedPOD">
					        <e-columns>			                   
					            <e-column field='id' :visible='false' :isPrimaryKey='true'></e-column>
					            <e-column field='name' :headerText="$t('Topo.podName')" width='130' :template='nameTemplate'></e-column>
					            <e-column field='status' :headerText="$t('Topo.runningStatus')" width='70'></e-column>		
					            <e-column field='ip' :headerText="$t('Topo.ip')" width='100'></e-column>	                    
					        </e-columns>
					</ejs-grid>	
		     </div> 
		    
		     <!-- /.END Form Type Two -->

      </div>
    </div>   

		<template>
			<ThreeListLinkageContainer :threeListLinkageContainer='threeListLinkageContainer'></ThreeListLinkageContainer>
		</template> 
  </div>
</template>

<script>	
	
	
	import nameLinkTemplate from "../../components/topoconfig/template/nameLinkTemplate.vue";
	
	//-- children panel
	import ThreeListLinkageContainer from "../../components/topoconfig/ThreeListLinkageContainer.vue";
  
	export default {
	    name: "FourListLinkagePanel",
	    components: {
	      ThreeListLinkageContainer
	    },
		computed: {
	     
	    },
	    data() {
		    return {	       
				dsPOD: [],
				nameTemplate: function () {
			         return { template : nameLinkTemplate}
			    },
			    selectOptions: { type: 'Single', mode: 'Row' },		
			    ip:'0.0.0.0',	
				cpuUsage: '0%',
				memoryUsage: '0M',
				cpuUsageList: [],
		      	memoryUsageList: [],			
				postModel: function(){		        	
				    this.environmentId = '';
				    this.nodeId = '';
			    },
		        alarmDetailObj: { id: this.id},
		        typeData: [],
		        typeCode: "",
		        icon: "",
		        online: "",
		        PositionXY: "",
		        postUrl: "",	        
		        serviceName: '',
		        see: false,
		        id: "",
		        type: "",
		        gridLines: 'None',
		        threeListLinkageContainer: {seeObj: false,  PositionXY: '', id: '', ip: '', name: '', namespace: '', status:'',  dsContainer: [] },
		        oprSetDialog: {
			        element: {
				            title: this.$t("Alarm.alarm"),
				            target: "#app",
				            isClose: true,
				            refName: "oprSetDia",
				            buttonGroup: [
					              {	click: this.dialogHide,
					                buttonModel: { content: this.$t("Topo.cancel") }
					              }
				            ]
			        },
			        styles: {
				            width: "810px",
				            height: "760px",
				            model: true,
				            visible: false,
			        }
		        }
		    };
	    },
	    props: ["threeListLinkagePanel"],
	    methods: {
	    
		      rowSelectedService: function( args ){
	    			if(args !=null && args.data.children !=null)
		        		this.dsPOD = args.data.children;	        		
		        	else
		        		this.dsPOD = [];	        	
		      },
		      rowSelectedPOD: function( args) {
		      		
		      		this.threeListLinkageContainer.seeObj = true;
		      		if(this.PositionXY == 'left:25px')
		      			this.threeListLinkageContainer.PositionXY = 'left:45px;'
		      		else
		      			this.threeListLinkageContainer.PositionXY = 'right:45px;'
		      		
		      		this.threeListLinkageContainer.id = args.data.id;
		      		this.threeListLinkageContainer.ip = args.data.ip;
		      		this.threeListLinkageContainer.name = args.data.name;
		      		this.threeListLinkageContainer.namespace = args.data.namespace;
		      		this.threeListLinkageContainer.status = args.data.status;
		      		this.threeListLinkageContainer.dsContainer = args.data.children;
		      
		      },		     
		      panelBoardGetData() {
		      
		      		//-- set default data
		      		this.dsPOD = [];					
					
			        let environmentId = 0;
			        if (this.parentId) {
				         environmentId = this.parentId;
			        }	       
	
			        var postParams = new this.postModel();
					postParams.environmentId = environmentId;
					postParams.nodeId = this.id;			
					
			        this.axios.post(this.postUrl, postParams).then(response => {
				          if (response && response.data.errorCode === "SUCCESS") {
					            const result = response.data.resultVal;
					            if (result) {					            	
					            	
					            	this.cpuUsage = '0%';
			        				this.memoryUsage = '0M';
			        				this.ip = result.k8sNode.ip;	
			        						            
					            	this.dsPOD = result.k8sNode.children;
					            	this.filterInit();
					            }
				          } 
				         
			        });
			        
		      }, 
		      filterInit(){
		      	
		      		this.cpuUsageList = [];
		      		this.memoryUsageList = [];			        
			        
		      		//-- filter 1st level	      		
		      		for( var i = 0 ; i < this.dsPOD.length ; i++)
		      		{
		      			if(this.dsPOD[i].children != null && this.dsPOD[i].children.length > 0)
		      			{	      				
		      				this.recursiveChildren(this.dsPOD[i].children);
		      			}				
		      		}     		
		      			      		
		      		this.cpuUsage = this.sumArray(this.cpuUsageList).toFixed(2) +'%';   
		      		this.memoryUsage = this.sumArray(this.memoryUsageList).toFixed(2) + 'M';	
		      				
		      }, 
		      recursiveChildren( pList){

		      		//-- only sum service Container		      		
	      			var filterCPU = pList.filter( w => (w.cpuUsage != null ));	      			
		      		var filterMemory = pList.filter( w => (w.memoryUsage != null));	
		      						
					if(filterCPU != null && filterCPU.length > 0)
					{
						for( var j = 0; j < filterCPU.length ;j++)
						{
							var num = parseFloat( filterCPU[j].cpuUsage.replace(/%/,'') );
							if( num > 0)
							{
								this.cpuUsageList.push(num);
							}										
						}						
					}
														
					if(filterMemory != null && filterMemory.length > 0)
					{
						for( var j = 0; j < filterMemory.length ;j++)
						{
							var num = parseFloat(filterMemory[j].memoryUsage.replace(/M/,''));
							if( num > 0)
							{
								this.memoryUsageList.push(num);
							}								
						}												
					}
						
		      },
		      sumArray(arr){
		      
		      	 	var sum = eval(arr.join("+"));
		      	 	return sum;	      	 
		      }, 
			  getLang( key){
			  
			  		return this.$t(key);
			  },    
		      click() {
			        this.see = !this.see;
		      }
		     
	    },	
	    mounted() {},
	    watch: {
	      //父子动态传值
	      threeListLinkagePanel: {
	        handler: function(newVal, oldVal) {        
	        	  
	        	  var changed = (newVal.idObj != this.id) ? true : false; 
	        	  
		          this.see = newVal.seeObj;          
		          this.id = newVal.idObj;
		          this.parentId = newVal.parentId;
		          this.type = newVal.typeObj;
		          this.serviceName = newVal.serviceName;
		          if(newVal.onlineObj===1){
		            this.online='h-pm-iconOnline';
		          }       
		          else if(newVal.onlineObj===0){
		            this.online='h-pm-iconOffline';
		          }
		          
		          this.PositionXY = newVal.PositionXY;	//-- panel position
		          this.typeCode = newVal.typeCode;
				  this.icon = newVal.icon;
				  this.postUrl = newVal.postUrl;
		          
		          //-- scroll to top  
		          /**
		          if(document.getElementsByClassName('scroll').length > 0) 
		          	document.getElementsByClassName('scroll')[0].scrollTop = 0; 
		          */	          
		          
		          if(newVal.seeObj == true && changed)
		          {
		          		this.panelBoardGetData();
		          }
		          
	        },
	        deep: true
	      }
	    }
  };
</script>

<style>
div.topo-alarm
{
	float: left;
    width: 100%;
    padding: 0 0 0 12px;
    color: #dddddd;
}

.topo-alarm a
{
	margin: 0 10px 0 10px;
	color: #dddddd;
	cursor: pointer;
	text-decoration: underline;
}

.topo-alarm .radius50
{
	width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
}

#gridPhysicPOD{

	background: #000000;
    border: 0 none;
}

.ThreeLinkagePanel .e-grid .e-gridheader
{
    background: #000000;
    border: 0 none;
    color: #dddddd;
}

.ThreeLinkagePanel.e-gridheader
{
    border: 0 none;
    color: #dddddd;
}

.ThreeLinkagePanel .e-grid .e-headercell, topoPanel .e-grid .e-detailheadercell
 {
    background: #000000;
    color: #dddddd;
}

.ThreeLinkagePanel .e-rowcell, .topoPanel .e-rowcell
{
	color: #dddddd;
}

.ThreeLinkagePanel .e-grid .e-content,
.ThreeLinkagePanel .e-grid .e-gridcontent
{
	background: #000000;
}

.ThreeLinkagePanel .e-row,
.ThreeLinkagePanel .e-grid .e-altrow
{
	background: #000000;
}

.ThreeLinkagePanel .e-headercontent
{
	border: 0 none !important;
}

.ThreeLinkagePanel .e-grid .e-content{
    background-color: #000000;
}

.ThreeLinkagePanel .e-rowcell.e-lastrowcell{
    border-bottom-width: 0px !important;
}

.ThreeLinkagePanel .e-headertext{
	font-size: 12px;
}

.ThreeLinkagePanel .e-emptyrow{
	display: none;
}

.ThreeLinkagePanel .e-grid.e-gridhover tr[role='row']:not(.e-editedrow):hover .e-rowcell:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell), 
.ThreeLinkagePanel .e-grid.e-gridhover tr[role='row']:hover .e-detailrowcollapse:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell), 
.ThreeLinkagePanel .e-grid.e-gridhover tr[role='row']:hover .e-rowdragdrop:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell), 
.ThreeLinkagePanel .e-grid.e-rtl .e-gridhover tr[role='row']:hover .e-rowdragdrop:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell), 
.ThreeLinkagePanel .e-grid.e-gridhover tr[role='row']:hover .e-detailrowexpand:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell){
	color: #dddddd;
}

/*正常情况下滑块的样式*/
.ThreeLinkagePanel .e-content::-webkit-scrollbar-thumb {
   background-color: #dddddd;
   border-radius: 10px;
   -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}

/*鼠标悬浮在该类指向的控件上时滑块的样式*/
.ThreeLinkagePanel .e-content:hover::-webkit-scrollbar-thumb {
   background-color: #dddddd;
   border-radius: 10px;
   -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}

/*鼠标悬浮在滑块上时滑块的样式*/
.ThreeLinkagePanel .e-content::-webkit-scrollbar-thumb:hover {
    background-color: #aaaaaa;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}

/*正常时候的主干部分*/
.ThreeLinkagePanel .e-content::-webkit-scrollbar-track {
   border-radius: 10px;
   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0);
   background-color: #aaaaaa;

}

/*鼠标悬浮在滚动条上的主干部分*/
.ThreeLinkagePanel .e-content::-webkit-scrollbar-track:hover {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.4);
    background-color: #aaaaaa;
}

.ThreeLinkagePanel .e-grid td.e-active
{
	 background: #555;
}

.ThreeLinkagePanel .e-grid .e-rowcell{

	color: #dddddd;
}

#gridPhysicPOD.e-grid .e-content {
    max-height: 378px;
    overflow-y: scroll;
}

</style>

